import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  MdBuild,
  MdSecurity,
  MdThumbUp,
  MdSupportAgent,
  MdAccessTime,
  MdVerified,
} from "react-icons/md";
import { motion } from "framer-motion";

const services = [
  {
    icon: <MdBuild size={36} />,
    title: "Soporte Técnico",
    desc: "Asistencia técnica profesional con personal capacitado.",
  },
  {
    icon: <MdSecurity size={36} />,
    title: "Seguridad Garantizada",
    desc: "Protegemos tu inversión con soluciones confiables.",
  },
  {
    icon: <MdThumbUp size={36} />,
    title: "Alta Calidad",
    desc: "Servicios y productos certificados con garantía.",
  },
  {
    icon: <MdSupportAgent size={36} />,
    title: "Atención Personalizada",
    desc: "Te asesoramos con un trato cercano y profesional.",
  },
  {
    icon: <MdAccessTime size={36} />,
    title: "Disponibilidad 24/7",
    desc: "Te atendemos en todo momento, sin importar la hora.",
  },
  {
    icon: <MdVerified size={36} />,
    title: "Certificación Garantizada",
    desc: "Técnicos certificados por marcas reconocidas.",
  },
];

const getAnimationVariant = (index) => {
  const variants = [
    {
      hidden: { opacity: 0, x: -50 },
      visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
    },
    {
      hidden: { opacity: 0, x: 50 },
      visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
    },
    {
      hidden: { opacity: 0, scale: 0.8 },
      visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } },
    },
    {
      hidden: { opacity: 0, rotateY: 90 },
      visible: { opacity: 1, rotateY: 0, transition: { duration: 0.6 } },
    },
    {
      hidden: { opacity: 0, y: -40 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    },
    {
      hidden: { opacity: 0, y: 40 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    },
  ];
  return variants[index % variants.length];
};

const WhyUs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <section
      style={{
        backgroundColor: "#f4f6f8",
        padding: "3rem 1rem",
        overflowX: "hidden",
      }}
    >
      <Box sx={{ textAlign: "center", mb: 5 }}>
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.2rem" },
            fontWeight: "bold",
            color: "#222",
            px: 2,
          }}
        >
          ¿Por qué elegirnos?
        </Typography>
        <Typography
          sx={{
            maxWidth: 700,
            mx: "auto",
            mt: 1,
            fontSize: { xs: "0.95rem", sm: "1rem" },
            color: "#555",
            px: 2,
          }}
        >
          Nuestra experiencia y compromiso nos distinguen. Conoce las razones
          que hacen de CMSOLTEC tu mejor opción.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 3,
          maxWidth: 1024,
          mx: "auto",
          px: 2,
        }}
      >
        {services.map((service, index) => {
          const variants = getAnimationVariant(index);
          return (
            <motion.div
              key={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={variants}
              style={{
                width: isMobile ? "100%" : "30%",
                maxWidth: 320,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Card
                elevation={2}
                sx={{
                  width: "100%",
                  padding: 3,
                  textAlign: "center",
                  borderRadius: "12px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box sx={{ mb: 2, color: "#ff6700" }}>{service.icon}</Box>
                <CardContent sx={{ p: 0 }}>
                  <Typography
                    variant="h5"
                    component="h3"
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "1.1rem", sm: "1.3rem" },
                      mb: 1,
                      color: "#222",
                    }}
                  >
                    {service.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: "0.9rem", sm: "1rem" },
                      color: "#666",
                    }}
                  >
                    {service.desc}
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          );
        })}
      </Box>
    </section>
  );
};

export default WhyUs;
